var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"background-color":"whitesmoke","background-size":"100%"},attrs:{"id":"Navigation"}},[_c('Menu'),_c('Erp'),_c('Logistics'),_c('Query'),_c('Knowledge'),_c('Payable'),_c('Img'),_c('Good'),_c('Fgl'),_c('Shopping'),_c('Trademark'),_c('Data'),_c('Forum'),_c('Util'),_c('Footer'),_c('el-backtop')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }